let config = {
  host: 'satisgaranti.com',
  restApi: 'https://api.satisgaranti.com/v1.0/'
};

export default config;